export const BRAND_ACCENTS = ['#0d827d', '#ff7a21', '#ffa6ec', '#1b1b1b']

const DARK_TEXT_LUMINANCE = 0.0069

const parseHex = (value: string | null | undefined): [number, number, number] | null => {
    if (!value) return null

    const hex = value.trim().replace(/^#/, '')
    const full = hex.length === 3 ? hex.split('').map(char => char + char).join('') : hex.slice(0, 6)

    if (!/^[0-9a-f]{6}$/i.test(full)) return null

    return [
        parseInt(full.slice(0, 2), 16),
        parseInt(full.slice(2, 4), 16),
        parseInt(full.slice(4, 6), 16)
    ]
}

const toLinear = (channel: number): number => {
    const value = channel / 255

    return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4
}

// Returns a usable hex color, falling back to a brand accent when the stored
// value is empty or not a hex color.
export const resolveAccent = (value: string | null | undefined, index: number): string => {
    const rgb = parseHex(value)

    if (!rgb) return BRAND_ACCENTS[index % BRAND_ACCENTS.length]

    return `#${rgb.map(channel => channel.toString(16).padStart(2, '0')).join('')}`
}

// Picks the text tone (white or near-black) with the best contrast on a background.
export const getReadableTone = (background: string): 'light' | 'dark' => {
    const rgb = parseHex(background)

    if (!rgb) return 'dark'

    const [r, g, b] = rgb.map(toLinear)
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b
    const contrastWithWhite = 1.05 / (luminance + 0.05)
    const contrastWithDark = (luminance + 0.05) / (DARK_TEXT_LUMINANCE + 0.05)

    return contrastWithWhite >= contrastWithDark ? 'light' : 'dark'
}
